import clsx from "clsx";

type InputFieldBaseProps = {
  label: string;
  id: string;
  register: any;
  labelClasses?: string;
  isDisabled?: boolean;
  isChecked: boolean;
  inputAdditionalClasses?: string;
};

function CheckboxWithLabel({
  label,
  id,
  register,
  labelClasses = "",
  isDisabled = false,
  isChecked,
  inputAdditionalClasses = "",
}: InputFieldBaseProps) {
  return (
    <div className="relative inline-flex flex-row items-center space-x-2 rounded-md">
      <div className="flex h-6 items-center">
        <input
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...register(id)}
          checked={isChecked}
          disabled={isDisabled}
          id={id}
          type="checkbox"
          className={clsx(
            "h-4 w-4 rounded border-gray-300 text-secondary focus:ring-secondary",
            inputAdditionalClasses,
          )}
        />
      </div>
      <div className={`ml-3 text-sm leading-6 ${labelClasses}`}>
        <label htmlFor={id} className="font-medium text-white">
          {label}
        </label>
      </div>
    </div>
  );
}
export default CheckboxWithLabel;

CheckboxWithLabel.defaultProps = {
  labelClasses: "",
  inputAdditionalClasses: "",
  isDisabled: false,
};
